import { render } from "./IconAddressLocation.vue?vue&type=template&id=17c5a168"
import script from "./IconAddressLocation.vue?vue&type=script&lang=ts"
export * from "./IconAddressLocation.vue?vue&type=script&lang=ts"
script.render = render

export default script